// Fallback catalogs used only before GET /clients/preference-options is cached.
// Runtime UI should prefer getters from `@/lib/clientPreferenceOptions`.
export const VALID_ALLERGIES = [
  { name: 'Tree Nuts', value: 'tree_nuts' },
  { name: 'Peanuts', value: 'peanuts' },
  { name: 'Sesame', value: 'sesame' },
  { name: 'Soy', value: 'soy' },
  { name: 'Dairy', value: 'dairy' },
  { name: 'Lactose', value: 'lactose' },
  { name: 'Gluten', value: 'gluten' },
  { name: 'Wheat', value: 'wheat' },
  { name: 'Eggs', value: 'eggs' },
  { name: 'Fish', value: 'fish' },
  { name: 'Shellfish', value: 'shellfish' },
  { name: 'Mollusks', value: 'mollusks' },
  { name: 'Sulfite', value: 'sulfite' },
  { name: 'Celery', value: 'celery' },
  { name: 'Corn', value: 'corn' },
  { name: 'Legumes', value: 'legumes' },
  { name: 'Lupin', value: 'lupin' }
] as const;

// Valid food intolerances
export const VALID_FOOD_INTOLERANCES = [
  { name: 'None', value: 'none' },
  { name: 'Lactose', value: 'lactose' },
  { name: 'Casein', value: 'casein' },
  { name: 'Gluten', value: 'gluten' },
  { name: 'Fructose', value: 'fructose' },
  { name: 'FODMAP', value: 'fodmap' },
  { name: 'Nightshade', value: 'nightshade' },
  { name: 'Lectin', value: 'lectin' },
  { name: 'Salicylate', value: 'salicylate' },
  { name: 'Histamine', value: 'histamine' },
  { name: 'Oxalate', value: 'oxalate' },
  { name: 'MSG', value: 'msg' },
  { name: 'Caffeine', value: 'caffeine' },
  { name: 'Sulfite', value: 'sulfite' },
  { name: 'Corn', value: 'corn' },
  { name: 'Yeast', value: 'yeast' },
  { name: 'Tannin', value: 'tannin' },
] as const;

// Intolerance tags for recipes (API: intoleranceTags array) – same shape as other options
export const RECIPE_INTOLERANCE_TAGS = [
  { name: 'Lactose', value: 'lactose' },
  { name: 'Casein', value: 'casein' },
  { name: 'Gluten', value: 'gluten_intolerance' },
  { name: 'Fructose', value: 'fructose' },
  { name: 'FODMAP', value: 'fodmap' },
  { name: 'Nightshade', value: 'nightshade' },
  { name: 'Lectin', value: 'lectin' },
  { name: 'Salicylate', value: 'salicylate' },
  { name: 'Histamine', value: 'histamine' },
  { name: 'Oxalate', value: 'oxalate' },
  { name: 'MSG', value: 'msg' },
  { name: 'Caffeine', value: 'caffeine' },
  { name: 'Sulfite', value: 'sulfite_intolerance' },
  { name: 'Corn', value: 'corn_intolerance' },
  { name: 'Yeast', value: 'yeast' },
  { name: 'Tannin', value: 'tannin' },
] as const;

// Valid dietary preferences (lifestyle choices)
export const VALID_PREFERENCES = [
  { name: 'Vegetarian', value: 'vegetarian' },
  { name: 'Vegan', value: 'vegan' },
  { name: 'Pescatarian', value: 'pescatarian' },
  { name: 'Paleo', value: 'paleo' },
  { name: 'Ketogenic', value: 'ketogenic' },
  { name: 'Keto', value: 'keto' },
  { name: 'Low Carb', value: 'low_carb' },
  { name: 'Low Fat', value: 'low_fat' },
  { name: 'Low Sodium', value: 'low_sodium' },
  { name: 'High Protein', value: 'high_protein' },
  { name: 'Balanced', value: 'balanced' },
  { name: 'High Fiber', value: 'high_fiber' },
  { name: 'Alcohol Free', value: 'alcohol_free' },
  { name: 'Kosher', value: 'kosher' },
  { name: 'Halal', value: 'halal' },
  { name: 'Whole30', value: 'whole30' },
  { name: 'Gluten Free', value: 'gluten_free' },
  { name: 'Dairy Free', value: 'dairy_free' }
] as const;

// Valid cuisine types for meal planning
export const VALID_CUISINE_TYPES = [
  { name: 'American', value: 'american' },
  { name: 'African', value: 'african' },
  { name: 'Nigerian', value: 'nigerian', parentId: 'african' },
  { name: 'Asian', value: 'asian' },
  { name: 'British', value: 'british' },
  { name: 'Caribbean', value: 'caribbean' },
  { name: 'Central Europe', value: 'central_europe' },
  { name: 'Chinese', value: 'chinese' },
  { name: 'Eastern Europe', value: 'eastern_europe' },
  { name: 'French', value: 'french' },
  { name: 'Greek', value: 'greek' },
  { name: 'Indian', value: 'indian' },
  { name: 'North Indian', value: 'north_indian', parentId: 'indian' },
  { name: 'South Indian', value: 'south_indian', parentId: 'indian' },
  { name: 'Italian', value: 'italian' },
  { name: 'Japanese', value: 'japanese' },
  { name: 'Korean', value: 'korean' },
  { name: 'Kosher', value: 'kosher' },
  { name: 'Mediterranean', value: 'mediterranean' },
  { name: 'Mexican', value: 'mexican' },
  { name: 'Middle Eastern', value: 'middle_eastern' },
  { name: 'Nordic', value: 'nordic' },
  { name: 'South American', value: 'south_american' },
  { name: 'South East Asian', value: 'south_east_asian' },
  { name: 'World', value: 'world' }
] as const;

// Health labels options for custom recipes
export const HEALTH_LABEL_OPTIONS = [
  { name: 'Gluten free', value: 'gluten_free' },
  { name: 'Dairy free', value: 'dairy_free' },
  { name: 'Low carb', value: 'low_carb' },
  { name: 'Low fat', value: 'low_fat' },
  { name: 'Low sodium', value: 'low_sodium' },
  { name: 'High protein', value: 'high_protein' },
  { name: 'High fiber', value: 'high_fiber' },
  { name: 'Alcohol free', value: 'alcohol_free' },
] as const;

// Diet labels options for custom recipes (values match API: underscores)
export const DIET_LABEL_OPTIONS = [
  { name: 'Vegetarian', value: 'vegetarian' },
  { name: 'Vegan', value: 'vegan' },
  { name: 'Pescatarian', value: 'pescatarian' },
  { name: 'Paleo', value: 'paleo' },
  { name: 'Ketogenic', value: 'ketogenic' },
  { name: 'Keto', value: 'keto' },
  { name: 'Low Carb', value: 'low_carb' },
  { name: 'Low Fat', value: 'low_fat' },
  { name: 'Low Sodium', value: 'low_sodium' },
  { name: 'High Protein', value: 'high_protein' },
  { name: 'Balanced', value: 'balanced' },
  { name: 'High Fiber', value: 'high_fiber' },
  { name: 'Alcohol Free', value: 'alcohol_free' },
  { name: 'Kosher', value: 'kosher' },
  { name: 'Whole30', value: 'whole30' },
  { name: 'Low sugar', value: 'low_sugar' },
  { name: 'Low GI', value: 'low_gi' },
  { name: 'Low GL', value: 'low_gl' },
] as const;

// Single combined list for recipe UI (API has one dietLabels array). Health + diet, deduped by value.
export const RECIPE_DIET_LABEL_OPTIONS = (() => {
  const byValue = new Map<string, { name: string; value: string }>();
  [...HEALTH_LABEL_OPTIONS, ...DIET_LABEL_OPTIONS].forEach((opt) => {
    if (!byValue.has(opt.value)) byValue.set(opt.value, { name: opt.name, value: opt.value });
  });
  return Array.from(byValue.values()).sort((a, b) => a.name.localeCompare(b.name));
})();

// Meal types options for custom recipes
export const MEAL_TYPE_OPTIONS = [
  { name: 'Breakfast', value: 'breakfast' },
  { name: 'Brunch', value: 'brunch' },
  { name: 'Lunch', value: 'lunch' },
  { name: 'Dinner', value: 'dinner' },
  { name: 'Snack', value: 'snack' },
  { name: 'Teatime', value: 'teatime' }
] as const;

// Dish types options for custom recipes
export const DISH_TYPE_OPTIONS = [
  { name: 'Main Dish', value: 'main-dish' },
  { name: 'Side Dish', value: 'side-dish' },
  { name: 'Appetizer', value: 'appetizer' },
  { name: 'Dessert', value: 'dessert' },
  { name: 'Beverage', value: 'beverage' },
  { name: 'Bread', value: 'bread' },
  { name: 'Snack', value: 'snack' },
  { name: 'Soup', value: 'soup' },
  { name: 'Sauce', value: 'sauce' },
  { name: 'Salad', value: 'salad' },
  { name: 'Sandwich', value: 'sandwich' },
  { name: 'Pasta', value: 'pasta' },
  { name: 'Pizza', value: 'pizza' },
  { name: 'Stir Fry', value: 'stir-fry' },
  { name: 'Casserole', value: 'casserole' },
  { name: 'Roast', value: 'roast' }
] as const;

// Cooking method options for recipe metadata
export const COOKING_METHOD_OPTIONS = [
  { name: 'Raw', value: 'raw' },
  { name: 'Boiled', value: 'boiled' },
  { name: 'Steamed', value: 'steamed' },
  { name: 'Sauteed / Stir-fried', value: 'sauteed_stir_fried' },
  { name: 'Roasted', value: 'roasted' },
  { name: 'Baked', value: 'baked' },
  { name: 'Grilled', value: 'grilled' },
  { name: 'Deep Fried', value: 'fried_deep_fried' },
  { name: 'Pressure cooked', value: 'pressure_cooked' },
  { name: 'Fermented', value: 'fermented' },
  { name: 'Multi-method', value: 'mixed_multiple' },
  { name: 'Cured', value: 'cured' },
  { name: 'Pickled', value: 'pickled' },
  { name: 'Dehydrated', value: 'dehydrated' },
  { name: 'Blanched', value: 'blanched' },
  { name: 'Poached', value: 'poached' },
  { name: 'Simmered', value: 'simmered' },
  { name: 'Braised', value: 'braised' },
  { name: 'Stewed', value: 'stewed' },
  { name: 'Slow cooked', value: 'slow_cooked' },
  { name: 'Griddled', value: 'griddled' },
  { name: 'Toasted', value: 'toasted' },
  { name: 'Smoked', value: 'smoked' },
  { name: 'Pan-fried', value: 'pan_fried' },
  { name: 'Shallow fried', value: 'shallow_fried' },
  { name: 'Air-fried', value: 'air_fried' },
  { name: 'Sous vide', value: 'sous_vide' },
  { name: 'Microwaved', value: 'microwaved' },
  { name: 'Blended', value: 'blended' },
] as const;

// Type definitions
export type AllergyType = typeof VALID_ALLERGIES[number];
export type PreferenceType = typeof VALID_PREFERENCES[number];
export type CuisineType = typeof VALID_CUISINE_TYPES[number];
export type HealthLabelType = typeof HEALTH_LABEL_OPTIONS[number];
export type DietLabelType = typeof DIET_LABEL_OPTIONS[number];
export type MealTypeType = typeof MEAL_TYPE_OPTIONS[number];
export type DishTypeType = typeof DISH_TYPE_OPTIONS[number];
export type RecipeIntoleranceTagType = typeof RECIPE_INTOLERANCE_TAGS[number];
export type CookingMethodType = typeof COOKING_METHOD_OPTIONS[number];

// Helper types for the new structure
export type OptionWithNameValue = {
  name: string;
  value: string;
};
